


































































import { Vue, Component } from 'vue-property-decorator'
import { userInfoForm } from '@/constants/applyForm'
import Uploader from '@/utils/uploads'
import FormItem from '@/components/form-item/index.vue'
import MTextarea from '@/components/m-textarea/index.vue'
import Radio from '@/components/Radio.vue'
import CheckBox from '@/components/check-box/index.vue'
import Mprotocol from '@/components/m-protocol/index.vue'
import { applyUserInfo, getCertifiInfo } from '@/services/apply'
import { CHECK_STATUS } from '@/constants/applyForm'

@Component({
  components: {
    FormItem,
    MTextarea,
    Radio,
    CheckBox,
    Mprotocol,
  },
})
export default class BaseInfo extends Vue {
  formData: ApplyTypes.UserInfoForm = userInfoForm
  avtImage: string = ''
  checked: Boolean = false
  $toast: any
  CHECK_STATUS = CHECK_STATUS

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get userInfo() {
    return this.$store.state.userInfo
  }

  goRead() {
    this.$emit('goRead')
  }
  // 提交申请
  async apply() {
    console.log('提交申请', this.formData)

    // if (!this.formData.invitationCode) {
    //   return this.$toast('请输入邀请码')
    // }
    if (!this.checked) {
      return this.$toast('请同意创作公约')
    }
    try {
      let data = {
        ...this.formData,
        uuid: this.userInfoInapp.uuid,
        ticket: this.userInfoInapp.ticket,
        avatar: this.avtImage,
        accountType: 1,
      }
      // if (data.avatar) {
      //   let url = new URL(data.avatar)
      //   data.avatar = url.pathname
      // }
      const res = await applyUserInfo(data)

      // const res = { code: 200 }
      if (res && res.code == 200) {
        this.$emit('goNext')
      } else {
        this.$toast(res.msg)
      }

      const { uuid, ticket } = this.userInfoInapp
      this.$store.dispatch('getColumnistInfoAction', { uuid, ticket })
    } catch (error) {
      console.log(error)
    }
  }
  // 上传头像
  onAvtImageChange(e: Event) {
    this.uploadImg(e, 'avtImage')
  }

  // 上传图片
  uploadImg(e: Event, type: string) {
    const target: HTMLInputElement = e.target as HTMLInputElement
    const files: FileList | null = target.files
    if (files && files.length) {
      const fileMaxSize = 1024 * 5 //最大5M
      const size = files[0].size / 1024
      if (size > fileMaxSize) {
        this.$toast('请上传5M以内的图片,请重新选择')
        target.value = ''
        return
      }

      // const { uuid, ticket } = this.userInfoInapp
      const PositiveUploader: any = new Uploader({
        file: files,
      })

      PositiveUploader.on('success', (info: any) => {
        ;(this as any)[type] = info.url
      })
    }
  }

  beforeMount() {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
  }

  mounted() {
    this.getSettedInfo()
  }

  // getCertifiInfo
  async getSettedInfo() {
    const res = await getCertifiInfo({
      uuid: this.userInfoInapp.uuid,
    })
    if (res.code === 200) {
      if (res.data && res.data.nickname !== '') {
        let resData = res.data
        console.log('resData', resData)
        this.formData.nickname = resData.nickname
        this.formData.introduction = resData.introduction
        this.avtImage = resData.avatar
      }
    }
  }
}
